const selectBlacklist = (state) => state.blacklist;
export const selectBlacklistData = (state) => selectBlacklist(state).data;
export const selectBlacklistTotal = (state) => selectBlacklist(state).total;
export const selectCsvBlacklist = (state) => state.csvBlacklist;
export const selectBlacklistEndedStatus = (state) => state.endedStatus;
